import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  recommendationsDeleteButton: {
    alignSelf: 'center',
    marginLeft: theme.spacing(1),
    height: '2rem',
    width: '2rem'
  },
  recommendationsFormControl: {
    minWidth: '100%'
  },
  recommendationsFormElement: {
    marginTop: theme.spacing(0.5),
    minWidth: '100%'
  },
  recommendationsInput: {
    flexGrow: 1
  },
  recommendationsTemplateInput: {
    marginBottom: theme.spacing(3),
    paddingLeft: theme.spacing(5.25),
    paddingRight: theme.spacing(5)
  }
}));

export default useStyles;
